// 顶部及底部菜单
export const menuList = [
  {
    index: "1",
    name: "关于西检",
    subList: [
      {
        index: "1-1",
        name: "集团简介",
        link: "/aboutUs/groupProfile",
      },
      {
        index: "1-2",
        name: "发展历程",
        link: "/aboutUs/development",
      },
      {
        index: "1-3",
        name: "企业文化",
        link: "/aboutUs/culture",
      },
      {
        index: "1-4",
        name: "企业荣誉",
        link: "/aboutUs/honor",
      },
      {
        index: "1-5",
        name: "院士工作站",
        link: "/aboutUs/workstation",
      },
    ],
  },
  {
    index: "2",
    name: "西检资讯",
    subList: [
      {
        index: "2-1",
        name: "集团动态",
        link: "/information/groupDynamics",
      },
      {
        index: "2-2",
        name: "行业动态",
        link: "/information/industryNews",
      },
      {
        index: "2-3",
        name: "行业知识",
        link: "/information/industryKnowledge",
      },
      {
        index: "2-4",
        name: "专题专栏",
        link: "/information/specialTopic",
      },
    ],
  },
  {
    index: "3",
    name: "业务与服务",
    subList: [
      {
        index: "3-1",
        name: "检验检测",
        link: "/products/detection",
      },
      {
        index: "3-2",
        name: "生态环境",
        link: "/products/environment",
      },
      {
        index: "3-3",
        name: "数字运营",
        link: "/products/digit",
      },
      {
        index: "3-4",
        name: "地质文勘",
        link: "/products/survey",
      },
      {
        index: "3-5",
        name: "培训中心",
        link: "/products/training",
      },
    ],
  },
  {
    index: "4",
    name: "人力资源",
    subList: [
      {
        name: "人才理念",
        link: "/resources/talentConcept",
      },
      {
        name: "招聘计划",
        link: "/resources/recruitingPlan",
      },
    ],
  },
  {
    index: "5",
    name: "子公司",
    subList: [
      // {
      //   index: "5-1",
      //   name: "西部第三方检测集团",
      //   link: "/aboutUs/groupProfile",
      // },
      {
        index: "5-2",
        name: "西部第三方检测集团（陕西）公司",
        // name: "陕西公司",
        link: "/aboutUs/shanxi",
      },
      {
        index: "5-3",
        name: "西部第三方检测集团（宁夏）公司",
        // name: "宁夏公司",
        link: "/aboutUs/ningxia",
      },
      {
        index: "5-4",
        name: "陕西西检生态环境技术有限公司",
        link: "/aboutUs/ecology",
      },
      {
        index: "5-5",
        name: "陕西西检数字技术运营有限公司",
        link: "/aboutUs/digit",
      },
      {
        index: "5-6",
        name: "陕西西检地质文物勘察技术有限公司",
        link: "/aboutUs/survey",
      },
      {
        index: "5-7",
        name: "陕西西检技术标准化培训中心有限公司",
        link: "/aboutUs/training",
      },
    ],
  }
];

// 集团简介
export const groupFile = {
  title: "西部第三方检测集团",
  content:
    "西部第三方检测集团有限公司（以下简称“西部检测集团”）是法定的第三方综合性检验检测服务机构。于2017年2月17日经国务院原国家工商总局核准成立，总部位于陕西省西安市浐灞生态区长安大学科技园。集团设有“院士工作站”、西部检测集团科学技术协会、",
  year: "2021",
  rich: "7.5",
  area: "52000",
};

// 关于西检-集团简介 
export const introduce = {
  title: "西部第三方检测集团",
  content1:
    "西部第三方检测集团有限公司（以下简称“西部检测集团”，英文缩写WTPTG）成立于2017年2月17日，经国务院原国家工商总局核准成立的国家级法定第三方综合性检测技术服务机构。",
  content2:
    "2021年，集团公司经西洽会招商引资入驻陕西省西安市浐灞生态区广运潭大道4555号长安大学科技园。园区总占地面积62.42亩，集团公司累计投资近7.5亿元，已建成国家级高标准A级实验室、科研办公场所、配套服务区域等25000㎡，拥有专业技术及管理团队400余人，下辖10家子公司与5个办事处，行业唯一的集成式科学技术协会，设立院士与专家工作站引领集团智慧力量。",
  content3:
    "集团公司业务以检验检测为根基，创新老行业新业态，推动产业附加值提升，科研信息化、环境与农业、工业与服务业五大产业，食品及农产品、中草药材检验检测、农业技术服务、生态环境技术服务、环保咨询与规划、高标准农田检测及验收、水污染、土壤、地质灾害修复治理、数字技术运营、信息网络安全检测、商用密码检测、认证认可服务、地质勘察与文物保护技术服务、专项应急预案、专业人才培训等领域，",
  content4: 
    "为各级政府部门、科研院所、工矿企业提供信息网络运营维护全链条业务软硬兼备的综合平台以及权威、精准、高效的一站式技术服务和解决方案。",
  content5:
    "集团公司以发展培育新质生产力为核心战略，推动产业高质量与高标准发展。积极创新服务模式，通过构建“检研企发展共同体”，实现从产品科研、生产控制到质量认证的全过程技术服务，帮助客户优化生产流程、降低运营成本、提升产品质量，助力产业集群化发展；探索政企院校产学研用战略合作机制，结合区域产业特色和高标准农田建设，不断培育新质生产力赋能乡村振兴，以综合性技术服务创新发展新动能，推动传统产业转型升级，为推动新型城镇化进程贡献力量。",
  content6:
    "集团公司高度重视社会责任目标，坚守“为行政高要求服务、为企业高质量服务、为社会高标准服务”的初心使命，牢记国家级企业的责任，通过法定、公正的专业技术能力，为消费者提供可靠的产品质量数据安全，助力打击假冒伪劣；在突发公共事件中快速响应，提供科学依据，通过公益性服务、科普教育等方式，以技术力量守护民生福祉，促进社会可持续发展。",
  content7:
    "集团公司深入贯彻落实《质量强国建设纲要》，聚焦产业发展关键技术，通过优化产业结构、完善管理体系、提升运营效能，全面发挥综合性技术服务机构在各领域的重要作用，为“十五五”期间的稳健发展筑牢坚实根基，捍卫人类生命健康努力而奋斗的崇高精神，引领创新、创业，凝聚全员力量，开拓进取、奋勇拼搏。在国家大力推进高质量发展下，集团公司充分发挥自身技术优势与专业实力，持续 拓展业务领域，不断提升品质力量。通过深化交流与合作，积极融合社会各界资源，进一步强化集团公司在行业中的领先地位与卓越影响力，为众多行业提供精准、高效、科学的综合性解决方案，以实际行动践行企业责任，为推进中国式现代化贡献西检力量，在新时代的浪潮中书写西部第三方检测集团的壮丽篇章！",
  // content7:
  //   "在食品安全领域，开展食品质量安全监测，严格把控食品从生产到流通的各个环节，确保市场上食品的安全可靠。同时，积极参与食品安全公益宣传，向消费者普及食品安全知识，提高公众的食品安全意识和辨别能力，守护人民群众“舌尖上的安全”。",
  // content8:
  //   "在医学领域，开展中草药医学检测，通过对中草药的质量检测和研究，推动中医药事业的发展，为公众提供更安全有效的中医药服务。此外，还关注医疗资源匮乏地区的医疗卫生状况，开展公益性的医学检测设备捐赠和医疗技术支援活动，助力提升基层医疗卫生水平，促进医疗公平。",
  // content9:
  //   "除了上述业务领域，西部检测集团还依据认证认可相关标准提供认证认可服务，依据培训标准开展检测人员资格培训业务等，为行业培养专业人才，推动检测行业的规范发展，为社会提供更加优质、高效的检测服务。",
  // content10:
  //   "立足当下，西部检测集团始终聚焦新质生产力这一关键核心，以推动高质量发展为首要目标。在发展过程中，集团不断探索创新服务模式，积极融入质量强国发展新格局，为产业链稳健发展与新兴产业茁壮壮大注入强劲动力。凭借精准赋能与持续的技术革新，精心打造“检企发展共同体”，实现质量技术服务全生命周期覆盖，助力企业降本增效、提质升级，推动产业建圈强链，促进区域经济高质量发展。同时，充分结合本地实际，深度挖掘并培育具有本地特色的新质生产力，将加快推进检验检测赋能产业升级作为关键抓手，全力推动新质生产力成长，加速构建现代化产业体系，为新型工业化进程添砖加瓦。在这个过程中，西部检测集团始终不忘公益初心，积极回馈社会，通过开展各类公益项目和活动，将企业的技术优势与社会需求相结合，为社会的和谐稳定发展贡献自己的力量。",
  // content11:
  //   "为深入贯彻《质量强国建设纲要》，西部检测集团正全力以赴加快新质生产力发展步伐，精准聚焦产业高质量发展过程中的堵点、难点、痛点问题，以检测协同创新为突破口，引领产业创新潮流。积极探索认证检测服务与强企强链强县战略的深度融合路径，推动检测业务与互联网、人工智能、大数据技术的深度耦合，加速建设“一站式”数字化服务平台，打破检测资源的区域与行业壁垒，实现资源共享与高效流通，优化检测供需对接流程，让数据多跑路、企业少跑腿，显著提升检验检测服务的整体效能。",
  // content12:
  //   "集团公司始终秉持“捍卫人类生命健康而努力奋斗”的初心与使命，以创新、创造、创业精神为引领，凝聚全员力量，奋力拼搏，朝着美好未来坚实迈进。在国家大力推进高质量发展、加快构建新发展格局的大背景下，西部检测集团将紧密围绕国家战略需求，充分发挥自身技术优势与专业实力，持续拓展业务领域，不断提升服务品质，以更加优质、高效、公正的检测服务，为社会的公益事业和经济建设保驾护航。",
  // content13:
  //   "展望未来，在推进中国式现代化的伟大征程中，西部检测集团始终铭记国家级企业所肩负的责任与使命，勇挑发展重担。通过重构业务板块发展体系，全方位提升管理效能，牢牢把握人才兴企、科技兴企两大核心，实现多点协同发力，为“十五五”期间的稳健发展筑牢坚实根基。同时，将继续坚守公益性原则，以实际行动践行社会责任，为社会的公平正义、人民的幸福安康、国家的繁荣昌盛不懈努力，让检测技术服务的成果更多更公平地惠及全体人民。",
};

// 关于西检-董事长寄语
export const chairmanMessage = {
  text1: "建设检测强企要把人才资源汇聚起来 ，干军易得，一将难求；",
  text2: "培养造就行业高水平领军人才、 卓越工程师、行业首席专家；",
  text3: "建设一支政治强、业务精、纪律严作风正的强大团队，",
  text4: "成为检验检测综合性技术服务专业机构，推动公益性服务；",
  text5: "发挥数字经济优势，赋能品牌力量， 培育新质生产力，实现质量强国目标努力而奋斗!",
}

// 子公司简介
export const subsidiaryIntro = {
  title: "陕西西检环境技术服务有限公司",
  content1:
    "陕西西检环境技术服务有限公司（以下简称“西检环境公司，英文缩写WIEC），位于陕西省西安市未央区⼴运潭⼤道4555号，是西部第三方检测集团全资子公司。取得了国家级科技型中小企业认定、ISO9001、ISO14001、ISO45001、CMMI3级、ITSS认证、双软企业等资质证书。",
  content2:
    "公司专业化的技术服务团队。其中，注册环评工程师5人，高级工程师8人，注册安全工程师2人，环境监理工程师5人，拥有国家生态环境部专家库成员，陕西省生态环境厅专家库成员。",
  content3:
    "作为中国环境科学学会团体会员、陕西环保产业协会会员单位，公司始终践行绿色发展理念，坚持“为行政高要求服务、为企业高质量服务、为社会高标准服务”的核心价值观，不断创新服务模式，提升服务质量，先后为中国石油集团、延长石油集团、宁夏宁东工业园区、青铜峡工业园区、内蒙古巴彦淖尔市工业园区、神木锦界工业园区、榆林工业园区、汉中空港工业园区等上百家优质客户提供了专业技术服务，得到了广大客户和环境管理部门的一致认可和高度肯定。",
  content4:
    "陕西西检环境技术服务有限公作为西部第三方检测集团环境业务板块排头兵，西检环境公司将继续践行使命担当和工匠精神，不断做强做优做大环保业务，奋发图强，为建设天蓝、地绿、水净、空气清新的美丽中国贡献西检力量。",
};

// 西检数字简介
export const digitIntro = {
  title: '陕西西检数字技术运营有限公司',
  content1: '领航数字科技创新，共赴智慧未来征程',
  content2: "陕西西检数字技术运营有限公司，是西部检测集团全资子公司，公司位于陕西省西安市浐灞生态区广运潭大道4555号。国家级科技型中小企业，国家高新技术企业，工信部增值电信业务经营许可证、ISO9001/14001/45001、CMMI3级、ITSS认证及双软企业等资质，陕西省区域大数据产业协会专业委员会会员，中国联通陕西分公司创新领域项目市场常态化供应商企业，国家发改委宏观经济研究院、西安邮电大学、西安电子科技大学等科研院所合作单位。",
  content3: "聚焦解决企业数字化转型三大核心痛点：数据安全与分析合法性、算力资源与业务需求动态匹配难题和多系统协同效率瓶颈，为政府及行业客户提供定制化解决方案，包括数字政府、智慧城市等平台级产品，及覆盖规划咨询、系统集成、运维优化的全生命周期服务。",
  content4: "企业优势：数字公司依托自主研发的智能数据平台和行业解决方案，以AI+大数据为核心，为企业提供高效、敏捷的数字化运营服务，相比传统运营商，动态资源调度能力和复杂场景整合能力，深度融合技术+场景+服务的三维优势，在精准营销、智能风控、供应链优化等领域实现降本增效30%+，并通过模块化系统与生态协同，精准赋能数字经济，助力快速构建数字化竞争力，驱动可持续增长，推动数字经济健康、稳定、高质量发展。",
  // content5: "展望未来，中国数字经济将在全球经济数字化转型浪潮中绽放蓬勃活力与巨大潜力。西检数字公司将紧抓百年难遇的发展机遇，在新质生产力创新引领下，勇立潮头，推动数字经济健康、可持续发展。以无畏勇气和卓越智慧，奋力谱写新时代数字经济高质量发展壮丽篇章，向着辉煌明天砥砺前行。让我们共同期待西检数字公司在数字征程中创造更多辉煌成就，激荡时代发展壮美华章！",
  businessText: "信息网络安全检测、商用密码产品认证检测、档案数字化、算力算法分析、算力中心建设、云计算、区块链、数据库运营管理、数字政府运营服务、法治网化综合分析、智慧城市大脑云、智慧交通可视化综合检测、数字园区可视化管理、智慧矿山综合管控等网络信息化监管平台的开发、建设、运营维护以及第一类、第二类增值电信业务、认证认可服务等",
  mainBusinessLists: [
    {
      imgUrl: require("@/assets/images/aboutUs/digit-icon1.png"),
      title: "网络信息化监管平台开发与运营",
      text: "开发运营监管平台，强化信息化管控",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/digit-icon2.png"),
      title: "数字政府运营管理",
      text: "运营管理数字政府，提升政务服务效能",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/digit-icon3.png"),
      title: "企业数字化转型解决方案",
      text: "提供企业数字化转型方案，助力业务升级",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/digit-icon4.png"),
      title: "商用密码认证检测",
      text: "开展商用密码认证检测，筑牢安全防线",
    },
  ],
  introduce: "陈平，1985年2月出生，2007年毕业于延安大学中文系，2007年至2015年在延安联通公司多区县任总经理，积累了丰富的管理、营销经验；2022年加入西部第三方检测集团，历任宁夏公司副经理、集团综合办主任、董事长助理等岗位，现任集团生态环境公司、数字公司及培训中心分管人，以卓越的学习能力不断践行在西部检测集团目标成长之路上。",
  name: "陈平",
  position: "数字公司负责人",
  telephone: "400-968-1018",
  avator: require("@/assets/images/aboutUs/appoint/appoint4.png")
}

// 西检生态简介
export const ecologyIntro = {
  title: '陕西西检生态环境技术有限公司',
  content1: "守护生态之美，领航环保新程",
  content2: "陕西西检生态环境技术有限公司，是西部检测集团全资子公司，公司位于西安市浐灞生态区广运潭大道4555号。获得中国环境科学学会、陕西环保产业协会会员单位，科技型中小企业，持有ISO9001/14001/ 45001、CMMI3级、ITSS认证及双软企业等资质。公司技术实力雄厚，聘有注册环评工程师5人、高级工程师8人、注册安全工程师2人、环境监理工程师5人以及国家、陕西省生态环保行业专家百余人。同时，与多所高校建立产学研用合作，定期开展技术培训与行业交流，持续提升团队专业素养与创新能力。",
  content3: "公司贯彻集团“三个服务”使命，已为中国石油、延长石油及宁夏、内蒙古、陕西等地上百家园区和企业提供专业技术服务，获得管理部门与服务对象一致认可。在生态环境高质量发展的新征程中，生态环境公司将继续秉持生态优先、绿色发展的理念，以尖端科学技术、智能数据平台为依托，实现全流程标准化运营，为山水林田湖草沙一体化保护和生态环境系统治理提供有力支持。",
  content4: "企业优势：集团科协和公司团队的超强技术加持，融合已累积经验（超百家技术服务经验+公司自主编制《技术服务工作手册》），创新工作流程、管理模式，制定科学化、精准化的解决、提升方案（一企一档、一园一策等），集成“科学检测+智慧平台”提供综合性、一站式技术服务，精准解决问题和困难。依靠院士、专家工作站，紧盯政策导向和前沿技术，科学超前预判，引领行业方向，为推动生态环境高质量发展、美丽中国建设做出应有贡献。",
  // content5: "公司业务广泛覆盖环保技术推广服务、ArcGis 系统及数据库建立、环境质量与污染介质修复、生态治理与保护等多个领域，形成从环境要素（水 / 气 / 土壤 / 固废）到食品农产品检测的立体化服务矩阵，以全链条服务能力与多元技术覆盖构建核心竞争力。",
  // content6: "依托集团国家级实验室资源与区域化检测网络布局，公司在重点流域水质监测、土壤污染详查等领域建立快速响应机制，深度响应国家环保政策，严格遵循 CMA/CNAS 等资质标准，为政府监管、企业合规提供全周期技术支撑。",
  // content7: "同时，公司积极开拓新兴业务赛道，针对新污染物检测、碳足迹核算、生态环境损害鉴定等前沿需求展开技术储备，研发团队持续攻关数字化监测与智能预警技术，精准把握“双碳”目标、土壤污染防治法等政策机遇，深度融入区域环境治理体系。",
  // content8: "在2025年国家生态环境建设的新征程中，陕西西检生态环境技术有限公司将继续秉持生态优先、绿色发展的理念，以高精度质谱色谱技术、智能数据平台为依托，实现“采样 - 分析 - 预警 - 治理”全流程标准化运营，为山水林田湖草沙一体化保护和系统治理提供有力支持。",
  // content9: "公司将以专业的技术、优质的服务，助力深入打好蓝天、碧水、净土保卫战，推动发展方式绿色转型，为建设人与自然和谐共生的美丽中国贡献智慧与力量，成为生态环境与食品质量安全领域兼具技术厚度与创新潜力的综合服务商，在生态环保之路上绽放独特魅力，书写绿色发展的辉煌篇章。",
  businessText: "公司涵盖农业技术服务、环境技术推广服务、ArcGis系统及数据库建立、环境质量与污染介质修复、生态环境治理与保护、生态调查、水土保持检测、大气污染治理、土壤污染治理、水环境治理、工业废弃物处理、矿山修复、环境咨询、认证与符合性评定、环保管家服务、碳资产开发与交易经纪、环保技术开发转让、工业三废治理、村镇水务治理、市政污水提标改造等多领域",
  mainBusinessLists: [
    {
      imgUrl: require("@/assets/images/aboutUs/ecology-icon1.png"),
      title: "环保医联体技术服务",
      text: "联动环保技术服务，助力环境协同治理",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/ecology-icon2.png"),
      title: "污染治理与生态修复工程",
      text: "实施污染治理与修复，重塑生态健康",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/ecology-icon3.png"),
      title: "双碳与生态安全技术服务",
      text: "技术支撑双碳目标，筑牢生态安全防线",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/ecology-icon4.png"),
      title: "全链条检测与溯源服务",
      text: "覆盖全链条检测，实现精准溯源",
    },
  ],
  introduce: "李曙芬，1988年9月出生，高级工程师，2011年本科毕业于宁夏大学环境科学专业，从事环保行业14年，从事环保咨询服务工作经验11年，独立负责项目类型包括区域及工业园区环保管家、区域及工业园区土壤及地下水调查工作、工业园区规划环境影响评价、建设项目环境影响评价等；从事环境监测行业3年，负责监测类型包括环境空气及废气、水及废水 、土壤及沉积物 、 固体废物、噪声等，具备深厚的专业北京和丰富的项目管理经验。",
  name: "李曙芬",
  position: "生态环境公司负责人",
  telephone: "029-86615681",
  avator: require("@/assets/images/aboutUs/appoint/appoint7.png")
}

// 陕西公司简介
export const shanxiIntro = {
  title: "西部第三方检测集团（陕西）有限公司",
  content1: "西部第三方检测集团（陕西）有限公司，是西部检测集团的全资子公司，位于陕西省西安市浐灞生态区广运潭大道4555号。公司投资2亿多元，建有11000㎡的国家A级实验室，配备科研、检验检测设备2000多台/套，摇杆无人机10架，智能走航车2辆，拥有200多名专业技术人才，从事 科 研 型 的 检 测 技 术 服 务 机 构 ， 国 家 级 高 新 技 术 企 业 。 通 过 中 国 计 量 认 证 （CMA）、农产品质量安全检测机构（CATL）认可参数5500余项，获得政府、行业及社会组织颁发的资质荣誉30余项。",
  content2: "公司秉持“制度化、规范化、标准化、高效化”的经营理念，对标国际国内一流检验检测机构，持续优化管理流程，加大科研投入，加强人才队伍建设，提升技术服务水平，树立行业标杆典范，致力于提供全链条的一站式技术服务，为人类生命健康、人民美好生活及社会经济可持续发展贡献力量。",
  content3: "企业优势：依托先进检验检测技术及天地空一体化监测数据为准，在食品领域提供从农产品质量到中草药材检测数据分析，在环境领域覆盖多场景监测与污染物数据评估，实现食品安全可追溯、生态环境科学评价。以数据全链条为检验检测解决方案，严格契合《食品安全法》、《环境保护法》等法规要求，推进自然生态环境保护及行业高标准、高质量发展。",
  businessText: "涵盖农业、环境、工业三大领域。农业领域以农产品质量安全检验、食品检测抽检、农药兽药残留、重金属、微生物、营养成分、添加剂、动物源性等多维度检测；中草药材检测涉及性状、真实性与纯度、毒性及功效成分、真菌毒素、元素类等指标检测。环境监测以农林环境、生态、生物、公共卫生、职业卫生检测，以及新型污染物检测、大气污染物溯源与评估、天地空一体化巡航监测，噪声振动、电磁辐射及放射性污染监测等。工业检测聚焦全流程质量管控，包括原材料质量检测、工艺参数监控、产品质量检验等。",
  mainBusinessLists: [
    {
      imgUrl: require("@/assets/images/aboutUs/shanxi-icon1.png"),
      title: "农产品/食品检测",
      text: "覆盖全链条检测，筑牢饮食安全屏障",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/shanxi-icon2.png"),
      title: "农业环境监测",
      text: "动态监测农业环境，守护生态基底",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/shanxi-icon3.png"),
      title: "工业与城市环境监测",
      text: "监测工业及城市环境，支撑治理优化",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/shanxi-icon4.png"),
      title: "技术支撑服务",
      text: "提供定制化技术方案，强化专业保障",
    },
  ],
  introduce: "韦石，出生于1988年4月，2011年毕业于大连工业大学食品安全与质量专业，2015年沈阳农业大学食品科学专业硕士研究生，高级工程师。2015年辽宁通正检测有限公司工作，2023年西部第三方检测集团工作，2024年5月担任西部第三方检测集团（陕西）有限公司副总经理，从事检验检测领域工作十年，具备专业的技术能力和丰富的管理经验，结合前沿科研能力与业务实践能力拓展市场。",
  name: "韦石",
  position: "陕西公司负责人",
  telephone: "029-86615681",
  avator: require("@/assets/images/aboutUs/appoint/appoint5.png"),
}

// 宁夏公司简介
export const ningxiaIntro = {
  title: "西部第三方检测集团（宁夏）有限公司",
  content1: "西部第三方检测集团（宁夏）有限公司，成立于2019年10月，注册资本2000万元，为西部检测集团全资子公司。位于银川贺兰德胜工业园，累计投资1.5亿元，员工200余人（其中高级职称30人），5000㎡国家A级实验室、二级微生物安全实验室（P2+）以及3000余台套检验检测科研设备设施，CATL、CMA双资质覆盖检测参数 达 7 0 0 0 余 项 ， 部 分 项 目 填 补 宁 夏 地 区 独 立 检 测 空 白 。 公 司 曾 先 后 获 得ISO9001、ISO14001、ISO45001体系认证，国家级科技型中小企业，“自治区人才小高地”等荣誉称号。",
  content2: "宁夏公司始终以高要求、高质量、高标准的服务地方经济发展为目标，致力于提升检验检测能力和科研技术能力，努力打造品质，树立行业标杆先锋，全力打响“西部检测集团”品牌矩阵。以“一流的人才，一流的技术，一流的设备，一流的服务”为地方经济发展提供技术支撑",
  content3: "企业优势：宁夏地区唯一拥有农产品和环境检测双资质的第三方检测机构。宁夏重点用能单位环境在线监测平台，宁夏回族自治区党委宣传部、科技厅、科学技术协会评为“自治区科普教育基地”，宁夏回族自治区市场监督管理厅评为“市场监管科普基地”，银川市人才局评为“环境、食品检测实验室建设人才小高地”。",
  businessText: "涵盖农产品质量检验、农业环境检测、技术咨询与培训、农产品质量安全相关研究、农药残留检测、兽药残留检测、重金属检测、微生物检测、营养成分检测、食品添加剂检测、工业废气、工业废水和噪声的检测、生产环境监测、产品质量检验、生态系统监测、生物污染检测、水质检测、空气质量检测、土壤检测、环境噪声污染检测、药材性状检测、药材真实性和纯度检测、毒性成分检测、有效成分含量测定、黄曲霉毒素检测、水质监测、大气污染监测、土壤和固体废弃物监测、生物污染监测、电磁辐射和放射性污染监测等众多行业领域，以及技术咨询服务与技能培训、农产品质量安全相关研究及质量检验检测等业务",
  mainBusinessLists: [
    {
      imgUrl: require("@/assets/images/aboutUs/nx-icon1.png"),
      title: "农产品质量安全检测",
      text: "全链条检测，筑牢农产品安全防线",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/nx-icon2.png"),
      title: "农业生态环境监测",
      text: "动态监测农业生态要素，守护生态平衡",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/nx-icon3.png"),
      title: "技术支撑与培训",
      text: "定制化培训方案，切实提升实操能力",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/nx-icon4.png"),
      title: "综合环境质量监测",
      text: "多维度监测环境，提供全方位评估支持",
    },
  ],
  introduce: "杨亚鹏，1980年10月出生，2003年毕业于陕西省商贸学院市场营销专业，2003年起先后从事图形工作站服务器产品的销售和渠道建设、自有品牌移动上网终端笔记本开发、智能停车项目研发推广、智慧交通建设、袁家村文旅项目开发等行业。2020年加入西部第三方检测集团，先后负责集团总部建设装修、子公司筹建、宁夏实验室装修搬迁等工作。2025年2月任宁夏公司负责人。具有20年多领域工作的丰富经验和不懈的奋斗精神。",
  name: "杨亚鹏",
  position: "宁夏公司负责人",
  telephone: "0951-8626769",
  avator: require("@/assets/images/aboutUs/appoint/appoint3.png")
}

// 西检培训简介
export const trainIntro = {
  title: "陕西西检技术标准化培训中心有限公司",
  content1: "陕西西检技术标准化培训中心有限公司，成立于2023年9月，是西部检测集团全资子公司，位于陕西省西安市未央区广运潭大道4555号，专注于为企业和个人提供高质量的专业知识、技能提升的培训服务机构，ISO9001、14001、45001体系认证及双软企业，专家院士3名、客座教授、高级讲师77名、检验检测资深讲师27名的百人师资团队，11000㎡超大型实景教辅基地，西北农林科技大学、西安建筑科技大学、陕西农林职业技术大学以及中国环境科学学会等科研院所合作单位。",
  content2: "培训中心秉承“行政的助手、行业的帮手、企业的扶手”经营理念，聚焦客户实际需求，结合最新的行业理论及优秀案例，精准制定个性化、差异化培训方案，全流程跟踪并及时反馈结果，着力为客户培养高能高素质人才、提供科研技术服务，帮助实现专业精进，推动组织效能提升。",
  content3: "企业优势：依托已建成CMA、CATL双资质认证的国家A级实验室和行业唯一集成式科协的强大软硬件实力，实现“理论+实操+认证”一体化、一站式培训模式，形成“全领域、多维度专业赋能”的核心优势，兼具技术深度与市场适应性的综合型赋能平台。培训中心本着“求真、务实、高效”的办学宗旨，为国家、行业培养高技能实用性人才、助力高质量发展贡献力量。",
  // content4: "在课程实施与教学效果的评估方面，公司构建严谨的评估体系。从课程实施的精细环节到最终效果呈现，全程紧密跟踪，精准评估，及时反馈结果，为课程优化提供有力依据。这种持续改进的机制，确保教学质量稳步攀升，如同精心培育的幼苗茁壮成长。",
  // content5: "为了保障课程实施的质量和效果，公司坚持严格的服务标准。秉持精益求精的态度，定期审查和完善工作流程，持续提升服务水平。以严谨规范的流程管理，为学员打造优质、高效的学习体验，让每一位学员都能在舒适、有序的环境中收获成长。",
  // content6: "公司以“全领域专业赋能”筑造核心优势，构建起覆盖食品安全、企业管理、职场礼仪、青少年科普、无人机操作、商用密码认证等多维度的立体化培训体系，宛如知识的百花园，满足不同学员的多样化需求。依托CMA认证实验室资源与行业资深专家团队，精心打造“理论教学+实操实训+资质认证”一体化模式，为学员铺就全面发展的康庄大道。",
  // content7: "食品安全培训紧扣新国标要求，从风险评估的精准分析到合规管理的系统指导，为学员提供全流程的深度培训，守护舌尖上的安全防线；企业管理课程聚焦战略规划与数字化转型，助力管理者突破瓶颈，引领企业迈向新的巅峰；无人机操作培训配备先进的模拟飞行系统与专业的户外实训基地，实现“考证+就业”无缝对接，为学员插上翱翔蓝天的翅膀。",
  // content8: "为提升教学质量，公司创新引入情景模拟、案例研讨、线上直播等多元教学手段，激发学员的学习兴趣与参与度。针对青少年开发趣味实验教具与科普研学项目，在孩子们心中播撒科学的种子；为商用密码领域定制攻防演练与认证辅导方案，助力学员在专业领域独占鳌头。",
  // content9: "此外，公司深度对接国家职业教育改革、“技能中国”行动等政策，与行业协会、高校共建实训基地，累计为食品企业、科技公司、政府机构输送百余名专业人才，成为行业发展的坚实后盾。凭借全产业链培训资质与精准化课程设计，公司在产教融合的大潮中乘风破浪，成为兼具技术深度与市场适应性的综合型赋能平台。",
  // content10: "展望未来，西检培训中心将继续秉承专业、创新的理念，不断完善自身服务体系，为更多企业和个人提供高质量的培训服务，为推动教育培训行业的发展贡献更多力量。",
  businessText: "涵盖农业、农产品、食品检测、生态环境、数字信息化、地质文勘等业务培训；检验检测行业技术人员培训、行政执法人员标准化业务培训；商用密码认证培训；计量技术服务；信息技术咨询服务；会议场地租赁、团体餐饮服务、企业拓展团建服务、青少年科技研学以及技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广等多个领域",
  mainBusinessLists: [
    {
      imgUrl: require("@/assets/images/aboutUs/training-icon1.png"),
      title: "农业技术培训",
      text: "传授实用农技，提升农业生产技能",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/training-icon2.png"),
      title: "安全环境培训",
      text: "讲解安全规范，强化环境风险防控能力",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/training-icon3.png"),
      title: "检验检测行业培训",
      text: "聚焦专业技能，助力掌握检测标准与规范",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/training-icon4.png"),
      title: "商用密码认证培训",
      text: "解析密码认证体系，筑牢安全应用能力",
    },
  ],
  introduce: "陈平，1985年2月出生，2007年毕业于延安大学中文系，2007年至2015年在延安联通公司多区县任总经理，积累了丰富的管理、营销经验；2022年加入西部第三方检测集团，历任宁夏公司副经理、集团综合办主任、董事长助理等岗位，现任集团生态环境公司、数字公司及培训中心分管人，以卓越的学习能力不断践行在西部检测集团目标成长之路上。",
  name: "陈平",
  position: "培训中心负责人",
  telephone: "029-86615681",
  avator: require("@/assets/images/aboutUs/appoint/appoint4.png")
}

// 西检文勘简介
export const surveyIntro = {
  title: "陕西西检地质文物勘察技术有限公司",
  content1: "陕西西检地质文物勘察技术有限公司，是西部检测集团全资子公司，注册资本500万元，位于陕西省西安市未央区广运潭大道4555号。公司持有岩土工程勘察乙级、水文地质勘察乙级、岩土工程物探测试检测监测乙级等行业资质以及科技型中小企业资质认定、ISO9001、ISO14001、ISO45001等权威证书。配备专业化技术团队30余人以及高精度三维激光扫描仪、多功能地球物理探测仪、便携式光谱分析仪、无人机激光雷达等先进设备设施百余台套，保证不同类型、不同规模项目的需求。",
  content2: '公司是集团为响应国家政策要求，改变项目管理方式由“粗放式”向空间化、数字化、科学化发展要求，培育的新质业务领域。凭借深耕检验检测领域多年所积累的雄厚底蕴及自主研发的智能数据处理平台，能高效完成复杂环境下的无损勘察，兼顾文物保护与地质安全，以"技术+合规"双优势为客户提供科学可靠的定制化解决方案。',
  content3: "企业优势：紧密依靠集团科协，即时组建多学科、多专业的顶尖技术团队，依托国家文物局、陕西省文物局、陕西省考古研究院等行业权威机构，用高精度勘察设备及先进信息化技术，深度融合集团在生态环境和数字技术领域的优势，构建起独特的“组合拳”模式，形成地质勘察与文物保护领域难以复制的核心竞争力，在现代化项目前期申报阶段发挥不可替代的作用。",
  // content4: "此外，公司凭借全链条技术服务能力，精心打造核心竞争力，深度响应国家矿产资源开发、国土空间规划以及地质灾害防治相关政策。在项目实施过程中，严格遵循 CMA、地质灾害防治工程勘查/设计甲级等资质标准，为政府重大工程选址、企业矿产开发等提供合规化技术支撑，确保项目全周期风险可控，为项目的顺利推进保驾护航。",
  // content5: "依托集团国家级地质实验室资源以及区域化勘查网络布局，公司在秦岭生态保护、黄河流域地质灾害防治等重点区域建立起快速响应机制，展现出强大的应急处理能力。同时，公司积极开拓数字化地质勘察、矿山环境综合治理、土壤污染修复等新兴业务领域，为传统业务注入新活力。研发团队深耕无人机遥感测绘、三维地质建模、自动化监测预警等技术，形成“传统勘查 + 智慧地质”双轮驱动模式，推动公司技术不断创新与发展。凭借资深专家团队与先进物探/化探设备储备，公司精准把握国家新一轮找矿突破战略、城市地下空间开发等政策机遇，成功在自然资源管理、工程建设领域确立了兼具技术深度与区域服务优势的专业服务商地位，为行业的进步和地区的发展贡献着自己的力量，铺就文物保护与地质安全的坚实基石，绘就智慧勘察与资源开发的美好蓝图。",
  businessText: "地质+文物一体化勘察，先进技术+分析手段，全方位服务于基础地质勘查；岩土工程勘察；文物保护工程勘察、设计、施工、监理；建设工程勘察、设计、施工；水文地质勘查；地下水资源勘探与评价；地质勘查技术服务；矿产资源勘查等。依托多维度的勘察监测数据，制定科学化的防治措施，为地质灾害治理服务；地质灾害工程勘查、施工、监理；环境应急治理服务；生态恢复及生态保护服务等提供精准服务。公司业务还涉及文物文化遗址保护服务；生态保护区管理服务；自然遗迹保护管理；名胜风景区管理；司法鉴定；馆藏文物修复、复制、拓印；水利工程质量检测；建设工程质量检测等领域",
  mainBusinessLists: [
    {
      imgUrl: require("@/assets/images/aboutUs/survey-icon1.png"),
      title: "地质勘察与地下资源勘探服务",
      text: "勘察地质结构，勘探地下资源潜力",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/survey-icon2.png"),
      title: "文物保护工程一体化服务",
      text: "整合保护流程，保障文物存续安全",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/survey-icon3.png"),
      title: "地质灾害监测与防治",
      text: "监测灾害风险，强化防控处置能力",
    },
    {
      imgUrl: require("@/assets/images/aboutUs/survey-icon4.png"),
      title: "地质+文物数字化管理",
      text: "数字化整合数据，统筹地质与文物管理",
    },
  ],
  introduce: "陈平，1985年2月出生，2007年毕业于延安大学中文系，2007年至2015年在延安联通公司多区县任总经理，积累了丰富的管理、营销经验；2022年加入西部第三方检测集团，历任宁夏公司副经理、集团综合办主任、董事长助理等岗位，现任集团生态环境公司、数字公司及培训中心分管人，以卓越的学习能力不断践行在西部检测集团目标成长之路上。",
  name: "陈平",
  position: "地质文勘公司负责人",
  telephone: "029-86615681",
  avator: require("@/assets/images/aboutUs/appoint/appoint4.png")
}

// 生态业务
export const environment = {
  title: "生态业务",
  text: "广泛覆盖环保技术推广服务、ArcGis系统及数据库建立、环境质量与污染介质修复、生态治理与保护等多个领域，形成从环境要素（水/气/土壤/固废）到食品农产品检测的立体化服务矩阵，以全链条服务能力与多元技术覆盖构建核心竞争力。针对新污染物检测、碳足迹核算、生态环境损害鉴定等前沿需求展开技术储备，持续攻关数字化监测与智能预警技术，精准把握“双碳”目标、土壤污染防治法等政策机遇，深度融入区域环境治理体系",
  productsLists: ["“环保医联体”全过程环境技术服务", "环境影响评价", "排污许可管理", "建设项目竣工环境保护验收", "突发环境事件应急预案", "土壤调查类", "地下水污染状况调查", "清洁生产审核", "碳核算及碳减排指导", "环境检测服务", "环境保护培训"],
  productSeries: [
    {
      image: require("@/assets/images/products/environment-product1.png"),
      title: "“环保医联体”全过程",
      subTitle: "专家驻厂，源头控污，助企绿色经营",
      list: [
        "现场诊断与“体检”",
        "协助整改与“治疗”",
        "组织验收与“保健”"
      ]
    },
    {
      image: require("@/assets/images/products/environment-product2.png"),
      title: "环境合规准入服务",
      subTitle: "环评、许可、验收全周期精准卡点",
      subTitle2: "助力项目合规投产",
      list: [
        "评审环节技术攻坚",
        "排污许可证一站式管理",
        "环保竣工验收保障",
        "环保新政实时预警"
      ]
    },
    {
      image: require("@/assets/images/products/environment-product3.png"),
      title: "环境风险管控服务",
      subTitle: "地空联诊+智能预警",
      subTitle2: "让污染事故归零企业安心",
      list: [
        "隐蔽排污精准狙击",
        "突发事故预演",
        "环保事故应急处置"
      ]
    },
    {
      image: require("@/assets/images/products/environment-product4.png"),
      title: "绿色低碳发展服务",
      subTitle: "为您提供专业的资讯及解决方案",
      // subTitle2: "想您所想",
      list: [
        "清洁生产全链条优化",
        "帮助企业落实双碳政策",
        "碳资产开发收益",
        "低碳技术咨询"
      ]
    },
  ],
  advantageLists: [
    {
      imgUrl: require("@/assets/images/products/environment-icon.png"),
      title: "全链条多元化服务",
      text: "覆盖多领域、全链条",
      text2: "立体化服务矩阵"
    },
    {
      imgUrl: require("@/assets/images/products/environment-icon.png"),
      title: "产品方案体系健全",
      text: "涵盖多元产品及解决方案",
      text2: "满足企业全场景需求"
    },
    {
      imgUrl: require("@/assets/images/products/environment-icon.png"),
      title: "前沿化技服融合",
      text: "专家驻厂、智能预警",
      text2: "响应政策与前沿需求"
    },
    {
      imgUrl: require("@/assets/images/products/environment-icon.png"),
      title: "绿色合规双驱动",
      text: "绿色低碳服务+合规支持",
      text2: "助力企业绿色运营"
    },
  ],
  contactList: [
    {
      companyName: "陕西西检环境技术有限公司",
      telephone: "400-968-1018",
      address: "陕西省西安市广运潭大道45555号",
    },
    {
      companyName: "西部第三方检测集团（宁夏）有限公司",
      telephone: "0951-8626769",
      address: "宁夏回族自治区银川市贺兰工业园",
    },
  ]
}

// 数字业务
export const digit = {
  title: "数字业务",
  text: "深度融合大数据、云计算、区块链、数据库平台等前沿技术，构建核心技术优势。已开发商用密码认证检测、数字政府运营管理、智慧城市大脑云、智慧交通可视化综合管理、数字园区可视化管理、智慧矿山综合管控等网络信息化监管平台，为社会高效运转提供数字支撑。依托自主知识产权，打造企业数字化转型全方案，以数据驱动与AI模型驱动为双引擎，提升运营效率，筑牢数字化转型算力基础",
  productsLists: ["数字政府运营管理平台", "智慧城市大脑云平台", "城市信息模型可视化平台", "数字交通一体化管理云平台", "应急指挥调度应用平台", "智慧环保可视化监测平台", "自然资源管理可视化大屏", "治安综合管理平台", "智慧司法大数据平台", "智慧工厂运营管理平台"],
  productSeries: [
    {
      image: require("@/assets/images/products/digit-product1.png"),
      title: "城市智能治理中枢",
      subTitle: "城市级决策与应急指挥",
      list: [
        "数字政府运营管理平台",
        "智慧城市大脑云平台",
        "应急指挥调度应用平台",
        "治安综合管理平台",
      ]
    },
    {
      image: require("@/assets/images/products/digit-product2.png"),
      title: "数字孪生可视化矩阵",
      subTitle: "全域空间精准映射与管控",
      list: [
        "城市信息模型（CIM）可视化平台",
        "自然资源管理可视化大屏",
        "数字园区可视化管理平台",
        "智慧矿山综合管控平台"
      ]
    },
    {
      image: require("@/assets/images/products/digit-product3.png"),
      title: "环境风险管控服务",
      subTitle: "驱动实体经济提质增效",
      list: [
        "产业经济大脑",
        "智慧工厂运营管理平台",
        "农产品溯源系统",
        "智慧文旅云平台"
      ]
    },
    {
      image: require("@/assets/images/products/digit-product4.png"),
      title: "保障协同体系建设",
      subTitle: "生态与公共安全联防联控",
      list: [
        "智慧环保可视化监测平台",
        "数字交通一体化管理云平台",
        "智慧司法大数据平台",
      ]
    },
  ],
  advantageLists: [
    {
      imgUrl: require("@/assets/images/products/digit-icon.png"),
      title: "前沿技术深度融合",
      text: "深度融合大数据、云计算等前沿技术",
      text2: "精准锚定数字化领域，构建核心技术优势"
    },
    {
      imgUrl: require("@/assets/images/products/digit-icon.png"),
      title: "产品覆盖多元场景",
      text: "涵盖政务、城市、产业、生态等",
      text2: "多领域平台，广泛适配元应用场景"
    },
    {
      imgUrl: require("@/assets/images/products/digit-icon.png"),
      title: "产品体系协同联动",
      text: "分系列构建智能治理、数字孪生等产品矩阵",
      text2: "实现跨领域协同与全场景覆盖"
    },
    {
      imgUrl: require("@/assets/images/products/digit-icon.png"),
      title: "自主创新赋能转型",
      text: "依托自主知识产权",
      text2: "提供数字化转型全方案"
    },
  ],
  contactList: [
    {
      companyName: "陕西西检数字技术运营有限公司",
      telephone: "400-968-1018",
      address: "陕西省西安市广运潭大道45555号",
    },
  ]
}

// 检测业务
export const detection = {
  title: "检测业务",
  text: "提供覆盖农业、工业、环境及中药材四大领域的全方位检测技术服务，构建从源头到终端的质量安全管控体系。在农业领域，重点开展农产品质量检测（农药残留、兽药残留、重金属、微生物、营养成分及食品添加剂等）和农业环境监测（土壤、水质、空气）；工业领域涵盖废气废水噪声检测、原材料及产品质检、生产环境监测；环境领域实施水质、大气、土壤固废、噪声振动、辐射及生态系统等全要素监测；中药材领域专注性状鉴别、真伪鉴定、有效成分分析及毒素检测。依托先进检测技术和智能化监测手段，我们为政府监管、企业生产和科研创新提供一站式专业服务，致力于保障产品质量安全、推动绿色发展和维护生态环境健康",
  productsLists: ["农产品质量安全检测", "农业生态环境监测", "技术支撑与培训", "综合环境质量监测", "农产品/食品检测", "农业环境监测", "工业与城市环境监测", "风险排查", "技术支撑服务"],
  productSeries: [
    {
      image: require("@/assets/images/products/detection-product1.png"),
      title: "农产品与食品质量安全检测",
      subTitle: "精严检测，守护舌尖安全",
      list: [
        "农残/兽残靶向检测",
        "重金属检测",
        "生物毒素全项分析",
        "营养组分检测",
        "食品添加剂限量评估",
        "绿色食品、有机产品、HACCP体系认证检测与服务",
        "智能化技术赋能",
      ]
    },
    {
      image: require("@/assets/images/products/detection-product2.png"),
      title: "农业与生态环境监测",
      subTitle: "全景监测，守护生态粮仓",
      list: [
        "土壤健康诊断",
        "水质安全预警",
        "大气污染溯源",
        "生态系统健康评估",
        "灾害风险防控",
        "有机农场认证",
        "污染责任界定",
      ]
    },
    {
      image: require("@/assets/images/products/detection-product3.png"),
      title: "环境综合监测 ",
      subTitle: "全域感知，智守绿水青山",
      list: [
        "全要素监控体系",
        "污染物精准溯源",
        "环境预警与治理闭环",
        "场景化解决方案服务"
      ]
    },
    {
      image: require("@/assets/images/products/detection-product4.png"),
      title: "技术支撑服务",
      subTitle: "技术赋能，让每一份检测都精准可靠",
      list: [
        "定制化检测方案",
        "检测人员能力提升体系",
        "实验室认证全流程托管",
        "实验室升级服务",
      ]
    },
  ],
  advantageLists: [
    {
      imgUrl: require("@/assets/images/products/detection-icon.png"),
      title: "检测全域覆盖",
      text: "检测范围超同业均值",
      text2: "食品、环境检测全链条打通"
    },
    {
      imgUrl: require("@/assets/images/products/detection-icon.png"),
      title: "检测品质过硬",
      text: "国家级、省级监管项目首选合作伙伴",
    },
    {
      imgUrl: require("@/assets/images/products/detection-icon.png"),
      title: "认证托管服务",
      text: "实验室认证全托管服务，专业可靠",
    },
    {
      imgUrl: require("@/assets/images/products/detection-icon.png"),
      title: "软硬件配置高",
      text: "全套进口检测设备，实验室全员持证上岗",
    },
  ],
  contactList: [
    {
      companyName: "西部第三方检测集团（陕西）有限公司",
      telephone: "400-968-1018",
      address: "陕西省西安市广运潭大道45555号",
    },
    {
      companyName: "西部第三方检测集团（宁夏）有限公司",
      telephone: "0951-8626769",
      address: "宁夏回族自治区银川市贺兰工业园",
    },
  ]
}

// 培训业务
export const training = {
  title: "培训业务",
  text: "聚焦培训需求分析，深度拆解客户实际诉求，精心打磨调研全流程。通过多元调研手段，精准捕捉客户深层需求，让解决方案如量身定制般精准适配，全方位响应多样化需求。集结行业菁英，融合前沿理论与经典案例，为客户定制贴合其特性的个性化课程。核心业务覆盖农业、农产品、食品检测、安全环境等领域培训，持续为行业输送专业人才",
  productsLists: ["农业技术培训", "安全环境培训", "检验检测行业培训", "商用密码认证培训", "环境相关政策培训"],
  productSeries: [
    {
      image: require("@/assets/images/products/training-product1.png"),
      title: "检验检测行业培训",
      subTitle: "针对检验检测技术人员与行政执法者",
      subTitle2: "提供专业能力提升与执法规范培训",
      list: [
        "检验检测仪器设备操作与校准技术",
        "检测方法标准解读与实验误差控制",
        "检验检测报告编制规范与数据溯源管理",
        "行政执法流程与证据采集技巧",
        "行业最新法规动态与案例分析",
      ]
    },
    {
      image: require("@/assets/images/products/training-product2.png"),
      title: "环境安全培训",
      subTitle: "围绕环境安全管理与风险防控",
      subTitle2: "提供系统性合规培训与实操指导",
      list: [
        "环境影响评价流程与技术规范",
        "工业三废（废水、废气、固废）处理技术与标准",
        "突发环境事件应急处置预案制定与演练",
        "安全生产与环境保护融合管理体系搭建",
        "环境监测技术与数据解读方法",
      ]
    },
    {
      image: require("@/assets/images/products/training-product3.png"),
      title: "农业技术培训 ",
      subTitle: "聚焦农业生产全链条",
      subTitle2: "提供涵盖种植、养殖及农产品加工的实用技术培训",
      list: [
        "农作物高效栽培技术与田间管理要点",
        "畜禽健康养殖模式及疫病防控措施",
        "农产品初加工与保鲜技术应用",
        "现代农业设施（温室、灌溉系统）操作与维护",
        "农业政策法规及绿色农业发展理念解读"
      ]
    },
    {
      image: require("@/assets/images/products/training-product4.png"),
      title: "商用密码认证培训",
      subTitle: "聚焦商用密码技术应用与认证规范",
      subTitle2: "培养符合行业前沿需求的专业人才",
      list: [
        "商用密码算法原理及安全应用场景",
        "密码产品检测认证流程与技术要求",
        "网络安全中密码技术的部署与防护策略",
        "商用密码管理条例及合规性审计方法",
        "新兴技术（云计算、区块链）中密码技术融合应用"
      ]
    },
  ],
  advantageLists: [
    {
      imgUrl: require("@/assets/images/products/training-icon.png"),
      title: "定制化服务",
      text: "精准调研客户诉求",
      text2: "定制贴合特性的解决方案"
    },
    {
      imgUrl: require("@/assets/images/products/training-icon.png"),
      title: "全领域产品覆盖",
      text: "涵盖四大领域培训",
      text2: "满足多行业人才培养需求"
    },
    {
      imgUrl: require("@/assets/images/products/training-icon.png"),
      title: "实用课程内容",
      text: "融合前沿理论与案例",
      text2: "兼顾理论与实操提升"
    },
    {
      imgUrl: require("@/assets/images/products/training-icon.png"),
      title: "行业精准赋能",
      text: "针对领域痛点设计课程",
      text2: "助力掌握必备技能与动态"
    },
  ],
  contactList: [
    {
      companyName: "陕西西检技术标准化培训中心",
      telephone: "400-968-1018",
      address: "陕西省西安市广运潭大道45555号",
    },
  ]
}

// 勘探业务
export const survey = {
  title: "勘探业务",
  text: "地质+文物一体化勘察，整合地质测绘、地球物理勘探、钻探等技术，结合高精度地质填图、三维建模及 GIS 空间分析，服务于工程地质勘察、地下水资源勘探与评价等。提供文物保护工程的方案设计、施工及监理，结合遗址特性制定科学保护方案。开展地质灾害监测与防治，依托卫星遥感、GPS 及物联网技术，实时监测地质变化并制定防治措施",
  productsLists: ["地质勘察与地下资源勘探服务", "文物保护工程一体化服务", "地质灾害监测与防治", "地质+文物数字化管理"],
  productSeries: [
    {
      image: require("@/assets/images/products/survey-product1.png"),
      title: "地质勘察与地下资源勘探",
      subTitle: "整合多项技术，提供地质勘察与地下资源勘探评价",
      list: [
        "高精度地质填图与三维地质建模",
        "地下水资源储量勘探与水质评价",
        "工程建设场地地质条件勘察分析",
        "矿产资源分布与开发潜力评估",
        "GIS空间分析技术在资源勘探中的应用",
      ]
    },
    {
      image: require("@/assets/images/products/survey-product2.png"),
      title: "文物保护工程一体化服务",
      subTitle: "针对遗址特性，提供文物保护全流程服务",
      list: [
        "文物遗址现状勘察与价值评估​",
        "科学保护方案设计（含修复、加固技术）",
        "文物保护工程施工技术实施",
        "工程质量监理与验收流程",
        "文物日常维护与监测方案制定",
      ]
    },
    {
      image: require("@/assets/images/products/survey-product3.png"),
      title: "地质灾害监测与防治",
      subTitle: "用先进技术实时监测地质灾害，制定防治措施",
      list: [
        "地质灾害隐患点排查与风险评估",
        "卫星遥感与GPS实时监测系统部署",
        "物联网传感器数据采集与分析",
        "滑坡、泥石流等灾害防治工程设计",
        "灾害预警机制与应急处置方案"
      ]
    },
    {
      image: require("@/assets/images/products/survey-product4.png"),
      title: "地质+文物数字化管理",
      subTitle: "以三维建模与 GIS 技术",
      subTitle2: "实现地质与文物数据数字化管理",
      list: [
        "地质环境与文物遗址数据采集与建档",
        "三维数字化建模（含地质体、文物本体）",
        "GIS空间信息管理系统搭建",
        "数据可视化展示与查询功能开发",
        "地质与文物关联数据共享平台建设 "
      ]
    },
  ],
  advantageLists: [
    {
      imgUrl: require("@/assets/images/products/survey-icon.png"),
      title: "一体化服务",
      text: "整合地质与文物领域",
      text2: "提供跨领域综合解决方案"
    },
    {
      imgUrl: require("@/assets/images/products/survey-icon.png"),
      title: "多元技术支撑",
      text: "运用测绘、遥感、三维建模等先进技术",
      text2: "保障服务精准高效"
    },
    {
      imgUrl: require("@/assets/images/products/survey-icon.png"),
      title: "全流程覆盖",
      text: "涵盖勘察、设计、施工、监测等全环节",
      text2: "满足全周期需求"
    },
    {
      imgUrl: require("@/assets/images/products/survey-icon.png"),
      title: "精准领域适配",
      text: "贴合地质、文物等领域特性",
      text2: "定制化解决实际问题"
    },
  ],
  contactList: [
    {
      companyName: "陕西西检地质文物勘察技术有限公司",
      telephone: "400-968-1018",
      address: "陕西省西安市广运潭大道45555号",
    },
  ]
}

// 集团动态
export const groupDynamicsList = [
  {
    date: "2025.07",
    lists: [
      {
        img: require("@/assets/images/information/image1.jpeg"),
        title:
          "西部检测集团举办安捷伦系列仪器专项培训",
        month: "07",
        day: "11",
        dateTime: "2025-04-18 11:31:29",
        content:
          "为深化检验检测领域技术能力，强化专业人才梯队建设，西部检测集团于2025年5月至7月期间，面向陕西、宁夏两地环境与食品实验室技术人员，开展为期三轮的安捷伦系列仪器专项培训。本次培训特邀安捷伦北京培训中心资深讲师团队，聚焦ICP - MS/ICP - OES/AAS、GC/GC - MS、LC/LC - MS等核心检测设备，通过理论与实操结合的模式，全面提升从业人员技术素养与实操水平。随着检测行业技术迭代加速，精准化、高通量检测需求日益增长，集团此次专项培训旨在夯实技术基础、强化实战能力、拓展应用维度。",
      },
      {
        img: require("@/assets/images/information/image2.jpeg"),
        title:
          "暖夏生辰颂 情聚西部行",
        dateTime: "2025-06-30",
      },
      {
        img: require("@/assets/images/information/image3.jpeg"),
        title:
          "节能降碳双驱发力 榆林奏响绿色新章",
        dateTime: "2025-06-30",
      },
      {
        img: require("@/assets/images/information/image4.jpeg"),
        title:
          "强化安全意识 筑牢安全防线",
        dateTime: "2025-06-30",
      },
      {
        img: require("@/assets/images/information/image5.jpeg"),
        title:
          "政企协同“双升双促”赋能服务 开启检测行业高质量发展新征程",
        dateTime: "2025-06-23",
      },
      {
        img: require("@/assets/images/information/image6.jpeg"),
        title:
          "深化环保检测协同创新 共筑绿色发展新生态",
        dateTime: "2025-06-23",
      },
      {
        img: require("@/assets/images/information/image7.jpeg"),
        title:
          '锦界高新区开展"6.5世界环境日"现场展板学习活动',
        dateTime: "2025-06-11",
      },
      {
        img: require("@/assets/images/information/image8.jpeg"),
        title:
          '校企合作谱新篇 协同发展启新程',
        dateTime: "2025-05-23",
      },
      {
        img: require("@/assets/images/information/image9.jpeg"),
        title:
          '西部第三方检测集团（陕西）有限公司成功通过 CMA 资质认定扩项评审',
        dateTime: "2025-04-27",
      },
    ]
  },
]
// 行业动态
export const industryNewsList = [
  {
    date: "2025.07",
    lists: [
      {
        img: require("@/assets/images/information/image11.jpeg"),
        title:
          "2025全球数字经济大会在京举行",
        month: "07",
        day: "11",
        dateTime: "2025-04-18 11:31:29",
        content:
          "新华社北京7月2日电（记者 阳娜、高亢）2025全球数字经济大会2日在京开幕。本届大会以“建设数字友好城市”为主题，吸引了上千名与会者参加，包括全球50多个国家及重要国际组织的300余位国际嘉宾。",
      },
      {
        img: require("@/assets/images/information/image12.jpeg"),
        title:
          "小浪底与西霞院水库：构建现代化运行管理矩阵，守护黄河安澜",
        dateTime: "2025-06-30",
      },
      {
        img: require("@/assets/images/information/image13.jpeg"),
        title:
          "第三轮中央生态环境保护督察",
        dateTime: "2025-06-24",
      },
      {
        img: require("@/assets/images/information/image14.jpeg"),
        title:
          "强化新型工业化绿色底色——国常会部署推进制造业绿色低碳发展",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image15.jpeg"),
        title:
          "中华人民共和国食品安全法（修正草案）》将提请全国人大常委会审议",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image16.jpeg"),
        title:
          "落实“双碳”行动 建设美丽中国",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image17.jpeg"),
        title:
          '将应对气候变化纳入生态文明建设整体布局和经济社会发展全局',
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image18.jpeg"),
        title:
          '加快绿色科技创新和先进绿色技术推广应用',
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image19.jpeg"),
        title:
          '陕西：省级环评审批时间压缩七成以上',
        dateTime: "2025-02-13",
      },
    ]
  },
]
// 行业知识
export const industryKnowledgeList = [
  {
    date: "2025.06",
    lists: [
      {
        img: require("@/assets/images/information/image21.jpeg"),
        title:
          "什么是“江河战略”",
        month: "06",
        day: "30",
        dateTime: "2025-04-18 11:31:29",
        content:
          "“江河战略”谋的不只是一条江、一条河，更是中华民族永续发展的千秋大计。正是因为始终从战略上思考问题，我们党不断深化对治水的规律性认识，推动“共抓大保护、不搞大开发”深入人心，人与自然和谐共生成为行动自觉。",
      },
      {
        img: require("@/assets/images/information/image22.jpeg"),
        title:
          "什么是“双碳”目标？",
        dateTime: "2025-06-17",
      },
      {
        img: require("@/assets/images/information/image23.jpeg"),
        title:
          "环保法律法规学习|《环境保护应知应会基础知识》",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image24.jpeg"),
        title:
          "农产品样品采集如何准备？",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image25.jpeg"),
        title:
          "农产品抽样常见标准有哪些？",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image26.jpeg"),
        title:
          "数智科普 | 传统矿山开采与智慧矿山区别和优势在哪里？",
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image27.jpeg"),
        title:
          '检测检验机构扩项评审，需要这么准备',
        dateTime: "2025-05-30",
      },
      {
        img: require("@/assets/images/information/image28.jpeg"),
        title:
          '介绍下市场上常用的食品检测方法',
        dateTime: "2025-05-30",
      },
    ]
  },
]

// 院士工作站
export const workstationData = {
  title: "科学技术协会/院士工作站",
  content1: "西部第三方检测集团科学技术协会（以下简称 “集团科协”），作为经中国社会科学院核准、陕西省科学技术协会批准同意设立的企业科学技术协会基层组织，是中国共产党领导下推动企业科技进步和助力世界科技强国建设的重要力量。自2022年8月成立以来，集团科协始终高擎习近平新时代中国特色社会主义思想伟大旗帜，立足新发展阶段，完整、准确、全面贯彻新发展理念，积极服务和融入新发展格局，全方位促进企业科技人才茁壮成长，深度激发企业技术创新活力，广泛拓展科学技术普及推广渠道，充分发挥科技智库的决策支撑作用，将企业广大科技工作者紧密团结凝聚在党的周围，自觉肩负起高水平科技自立自强的崇高使命与时代担当。凭借强大的人才吸纳能力，汇集了包括院士、教授、博导、行业专家等在内的众多领域顶尖学者，构建起一座连接集团公司与科技工作者的坚实桥梁，成为推动集团公司科研水平迈向新高度、技术创新实现新突破的中坚力量。",
  content2: "在科技创新实践中，集团科协积极整合各方资源，打造院士工作站这一高端创新平台，广泛吸引众多知名院士、专家亲临授课传经送宝，精心培育一批具有深厚专业造诣和丰富实践经验的 “西检人”实用性专家队伍，进一步优化院士工作站的功能性定位，使其在服务国家战略、推动行业发展、解决关键技术难题等方面发挥更大效能，切实为国家和社会输送一批政治素质过硬、业务能力精湛的真才实干专家，为实现高水平科技自立自强贡献西检智慧。",
  img1: require("@/assets/images/aboutUs/honor/img1.png"),
  img2: require("@/assets/images/aboutUs/honor/img2.png"),
  img3: require("@/assets/images/aboutUs/honor/img3.png"),
}

// export { menuList, groupFile, introduce, subsidiaryIntro, digitIntro, ecologyIntro, shanxiIntro, ningxiaIntro, trainIntro, surveyIntro };
